import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "users";

export const usersService = {
    getAll,
    get,   
    getAgents,
    getAgentsWithCaseDistance,
    getAllUsers,
    getAddress,
    createAddress,
    updateAddress
};

function getAll(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAll?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function get(id: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/Get/?id=${id}`, requestOptions).then(handleResponse);
}

function getAgents() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAgents`, requestOptions).then(handleResponse);
}
function getAgentsWithCaseDistance(caseSubjectId: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAgentsWithCaseDistance/?caseSubjectId=${caseSubjectId}`, requestOptions).then(handleResponse);
}
function getAllUsers() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAllUsers`, requestOptions).then(handleResponse);
}

function getAddress(id: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAddress/?id=${id}`, requestOptions).then(handleResponse);
}

function createAddress(model: any) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/createAddress`, requestOptions).then(handleResponse);
}

function updateAddress(model: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/updateAddress`, requestOptions).then(handleResponse);
}